import { Injectable } from '@angular/core'
import { GeographicOption } from '@se-po/shared-data-access-models'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { SeFeApiService } from 'se-fe-api'

@Injectable({
  providedIn: 'root'
})
export class GeographicOptionsService {

  public endpoint = 'geographic_options'

  constructor(private api: SeFeApiService) {
    // noop
  }

  public allCountries(): Observable<GeographicOption[]> {
    return this.api.get(`${this.endpoint}/countries?include_all=true`)
    .pipe(
      first(),
      map(response => response.result as GeographicOption[])
    )
  }
}
